<!-- Valid token - change password -->
<div *ngIf="validToken">
  <h2>Återställ lösenord</h2>

  <div class="content-wrapper">
    <form *ngIf="newPassForm" [formGroup]="newPassForm" (ngSubmit)="submit()">
      <mat-form-field *ngIf="!resetFinished">
        <input matInput name="newPass" formControlName="newPass" type="password" placeholder="Nytt lösenord"
          spellcheck="false" autocomplete="off">
      </mat-form-field>

      <mat-form-field *ngIf="!resetFinished">
        <input matInput name="repeatPass" formControlName="repeatPass" type="password" placeholder="Upprepa lösenord"
          spellcheck="false" autocomplete="off">
      </mat-form-field>
      <p *ngIf="message">{{message}}</p>

      <button class="button" *ngIf="!resetFinished" [disabled]="!newPassForm.valid" type="submit">Byt lösenord</button>
    </form>
    <button class="button" (click)="toLogin()">Tillbaka till logga in</button>
  </div>
</div>

<!-- Invalid token info -->
<div *ngIf="!validToken">
  <h2>Ogiltig länk</h2>

  <p>Någonting gick fel. Antingen har din länk gått ut, eller så är den felaktig. Prova igen.</p>
</div>